// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3QsW9","upload":"Small_upload__22cBc","imageWrap":"Small_imageWrap__1m3Fx","removeBtn":"Small_removeBtn__2eO4m"};